import React from "react";
import { Tooltip } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import FunctionsIcon from "@mui/icons-material/Functions";

import { logEvent } from "../../../../functions/amplitude";
import biasCenterImg from "../../../../media/images/bias-center.png";
import biasLeaningLeftImg from "../../../../media/images/bias-leaning-left.png";
import biasLeaningRightImg from "../../../../media/images/bias-leaning-right.png";
import biasLeftImg from "../../../../media/images/bias-left.png";
import biasRightImg from "../../../../media/images/bias-right.png";

import Smile from "../../../../media/images/smiley_icon.svg";
import bg5 from "../../../../media/images/default-thumbnail.png";
import ReceiptIcon from "@mui/icons-material/Receipt";

import { setpopupCardFooter } from "../../../../redux/features/stylesSlice";

import {
  setCitationPopup,
  setShowCharity,
  setSummarizePopup,
  setSummaryInfoData,
  setUrl,
} from "../../../../redux/features/dataSlice";
import { getFormattedDate, getRegularDate } from "../../../../functions/time";

export const biasImg = {
  Center: biasCenterImg,
  Mixed: biasLeftImg,
  Left: biasLeftImg,
  "Lean Left": biasLeaningLeftImg,
  Right: biasRightImg,
  "Lean Right": biasLeaningRightImg,
};

export const biasLink = {
  Center: process.env.REACT_APP_ALLLSIDES_CENTER,
  Mixed: biasLeftImg,
  Left: process.env.REACT_APP_ALLLSIDES_LEFT,
  "Lean Left": process.env.REACT_APP_ALLLSIDES_LEAN_LEFT,
  Right: process.env.REACT_APP_ALLLSIDES_RIGHT,
  "Lean Right": process.env.REACT_APP_ALLLSIDES_LEAN_RIGHT,
};

const handleImageError = (event) => {
  event.target.src = bg5;
};

export default function AcademiaNews(props) {
  const {
    data,
    bookmarkUrls,
    cardRef,
    setBookmarkData,
    setSaveBookmarkPopup,
    sectionTitle,
    academiaSearch,
    label,
    summaryAvailable,
    citationAvailable,
  } = props;

  const dispatch = useDispatch();

  const { search, academiaHeaderUrl } = useSelector((state) => state.data);

  const checkBookmark = (data) => {
    const changeUrl = data.url;
    if (bookmarkUrls.includes(changeUrl)) {
      return true;
    }
    return false;
  };

  const handleTitleClick = (newUrl) => {
    window.open(newUrl, "_blank");

    logEvent("click_resultset_title", {
      url: newUrl,
      query: search,
      entity: academiaSearch,
      category: sectionTitle,
      mediabiasrating: data.mediaBiasRating ? data.mediaBiasRating : "NA",
    });
  };

  const renderAuthors = (authors) => {
    if (authors?.length <= 2) {
      return authors.join(", ");
    } else {
      return authors.slice(0, 2).join(", ") + "...";
    }
  };

  const setAcademiaBookmarkData = (data) => {
    const bookmarkData = {
      publisher: academiaSearch,
      title: data.title,
      published_date: getFormattedDate(data.datePublished),
      url: data.url,
    };
    dispatch(setSummaryInfoData(bookmarkData));
  };

  return (
    data && (
      <div className="card-news" ref={cardRef}>
        <div
          className="card-footer"
          onClick={() => {
            dispatch(setShowCharity(Boolean(data.charityNavigatorScore)));
            dispatch(setpopupCardFooter(academiaHeaderUrl));
          }}
        >
          <div className="flex">
            <Tooltip title={academiaSearch} placement="bottom-start">
              <p
                className="entity-name"
                style={{
                  width: "20rem",
                }}
              >
                {label}
              </p>
            </Tooltip>
          </div>
          <div className="buttons"></div>
        </div>

        <div className="flex-title-academia">
          <h3
            className="title"
            onClick={() => {
              academiaSearch === "core"
                ? handleTitleClick(data.downloadUrl)
                : handleTitleClick(data.url);
            }}
          >
            {String(data.title).length > 150
              ? `${data.title.substring(0, 150)}...`
              : data.title
              ? data.title
              : "NA"}
          </h3>
          {data.hasPayWall && data.isPartner ? (
            <Tooltip title="We removed the paywall for you!">
              <img className="smiley" src={Smile} />
            </Tooltip>
          ) : (
            data.hasPayWall && (
              <Tooltip title="This source may limit your access without a subscription">
                <LockIcon />
              </Tooltip>
            )
          )}
        </div>
        <p className="desc-academia mt-2">
          <span>{getFormattedDate(data.datePublished)}</span> –{" "}
          {String(data.description).length > 180
            ? `${data.description.substring(0, 180)}...`
            : data.description
            ? data.description
            : "NA"}
        </p>
        <p className="desc mb-2">{`Author - ${renderAuthors(data.authors)}`}</p>
        <div className="header-card">
          <div
            className="popup-save"
            // on
          >
            {citationAvailable && (
              <Tooltip title="Cite this">
                <ReceiptIcon
                  onClick={() => {
                    dispatch(
                      setSummaryInfoData({
                        publisher: academiaSearch,
                        title: data.title,
                        published_date: getRegularDate(data.datePublished),
                        url: data.url,
                      })
                    );
                    dispatch(setCitationPopup(true));
                    dispatch(setUrl(data.url));
                  }}
                />
              </Tooltip>
            )}
            {summaryAvailable && (
              <Tooltip title="Generate article summary">
                <FunctionsIcon
                  onClick={() => {
                    dispatch(setUrl(data.url));
                    dispatch(
                      setSummaryInfoData({
                        publisher: academiaSearch,
                        title: data.title,
                        published_date: getRegularDate(data.datePublished),
                        url: data.url,
                      })
                    );
                    dispatch(setSummarizePopup(true));
                    setBookmarkData(data);
                  }}
                />
              </Tooltip>
            )}
            <Tooltip title="Add to my Collections">
              {bookmarkUrls && checkBookmark(data) ? (
                <BookmarkIcon
                  style={{ color: "#1b99e8" }}
                  onClick={() => {
                    setAcademiaBookmarkData(data);
                    setSaveBookmarkPopup(true);
                  }}
                />
              ) : (
                <BookmarkBorderIcon
                  onClick={() => {
                    setAcademiaBookmarkData(data);
                    setSaveBookmarkPopup(true);
                  }}
                />
              )}
            </Tooltip>
          </div>
        </div>
      </div>
    )
  );
}
